import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { RouterProvider } from 'react-router-dom';
import { PageLoader } from './components/page-loader';
import { queryClient } from './config/react-query';
import { router } from './routing/router';
import { antdTheme } from './theme';

const App = () => {
  const auth = useAuth();

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {
      auth.signinSilent();
    });
  }, [auth.events, auth]);

  useEffect(() => {
    if (
      !auth.isLoading &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.error
    ) {
      auth.signinRedirect();
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error, auth]);

  switch (auth.activeNavigator) {
    case 'signinSilent':
    case 'signoutRedirect':
      return <PageLoader />;
  }

  if (!auth.isAuthenticated && auth.isLoading) {
    return <PageLoader />;
  }

  if (!auth.isAuthenticated) {
    return <PageLoader />;
  }

  if (auth.error) {
    return (
      <ConfigProvider theme={antdTheme}>
        <PageLoader />
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider theme={antdTheme}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
